<template>
  <layout-content>
    <mailing-list :type="$route.params.type" />
    <template slot="top-buttons">
      <i-button type="primary" :to="{ name: 'mailer.mailing.create' }" size="large">
        {{ $t('mailer.breadcrumb.mailing.create') }}
      </i-button>
    </template>
  </layout-content>
</template>

<script>
  import MailingList from '@mailer/components/mailings/mailings-table';

  export default {
    components: {
      MailingList
    }
  };
</script>
